<template>
    <v-row class="mb-2 px-4 pb-2 pt-2">
			<v-col :class="'col-12'">
				<div class="d-flex" style="align-items: center">
					<div
						class="mode-choice"
						v-for="mode in modes"
						:key="mode"
						:class="{ active: mode == selected_mode }"
						@click="selected_mode = mode"
					>
						{{ $t(mode) }}
					</div>
				</div>
        <Calepinage v-if="this.selected_mode==='_calepinage_'"></Calepinage>
        <Agencement v-if="this.selected_mode==='_agencement_'"></Agencement>
      </v-col>
		</v-row>
</template>

<script>
import Calepinage from "@/components/Configuration/Calepinage.vue";
import Agencement from '@/components/Configuration/Agencement.vue';

  export default {
      components: {
        Calepinage,
        Agencement,
      },

      data() {
        return {
          script_name: "ExpertLayout.vue",
          selected_mode: null,
          modes: [],
          key_update: 0,
        };
      },

      watch: {
        '$route.params.id': {
          handler: function() {
            this.selected_mode='_calepinage_'
            this.modes.push('_calepinage_')
            this.modes.push('_agencement_')
          },
          deep: true,
          immediate: true
        },

    '$root.$i18n.locale': {
      handler() {
        this.key_update += 1
      },
      deep: true,
      immediate: true,
    },

	
  },

	methods: {
    
	},
};
</script>

<style scoped>
  .input {
  border: 1px solid #ededed !important;
  border-radius: 10px; 
  cursor: pointer;
  padding: 1px 10px;
  }

  .mode-choice {
	text-transform: capitalize;
	font-size: 18px;
	padding: 8px 20px;
	font-weight: 500;
	border-radius: 4px 4px 0 0;
}

.mode-choice.active {
	background-color: white;
	cursor: default;
}

.mode-choice:not(.active) {
	background-color: rgba(100%, 100%, 100%, 0.5);
	cursor: pointer;
}
</style>
